import { useState, useEffect } from "react";

const isWindowDesktopWidth = () => globalThis.innerWidth > 768;

const useDesktopChecker = () => {
  const [isDesktop, setIsDesktop] = useState(isWindowDesktopWidth);
  useEffect(() => {
    const handleResize = () => setIsDesktop(isWindowDesktopWidth);
    globalThis.addEventListener("resize", handleResize);
    return () => globalThis.removeEventListener("resize", handleResize);
  }, []);
  return isDesktop;
};

export default useDesktopChecker;
